
import { SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, Dropdown, Input, Menu, Row, Select, Space, Table, Tooltip, message, Form, Pagination } from 'antd';
import "jspdf-autotable";
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';

import { fetchPackingSlipDropdown, verifyPackingSlip, resetPackingSlip } from "../../slices/dispatch-verification"

function DispatchVerificationList() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { Option } = Select;
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dispatch = useDispatch();
  const {  totalRecord, status } = useSelector(state => state.dispatchVerification);

  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [selectedSlipNo, setSelectedSlipNo] = useState(null);
  const [verifyPackingSlipData, setVerifyPackingSlipData] = useState([]);
  const [packingSlipData, setPackingSlipData] = useState();
 
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'status',
    'weight',
    'pieces',
    'length',
    'profile_description',
    "die_profile",
    'bundle_no',
    'bundle_id',
  ]);


  useEffect(() => {

    const timeoutId = setTimeout(() => {
    }, 8000);
    const fetchPackingSlip = async () => {
      try {
        dispatch(fetchPackingSlipDropdown({}))
          .unwrap()
          .then(response => {
            setPackingSlipData(response?.data);
          })
          .catch(error => {
            console.error('');
          })
          .finally(() => {
            clearTimeout(timeoutId); // Clear the timeout if API responds
          });
      } catch (error) {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      }
    };

    setSelectedSlipNo([]);
    fetchPackingSlip();
  }, []);


  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  const handleVerifyPackingSlip = (newPage) => {
    if (!selectedSlipNo) {
      message.warning("Please select a slip number first.");
      return;
    }

    dispatch(resetPackingSlip());

    dispatch(
      verifyPackingSlip({
        slip_no: selectedSlipNo,
        page: 1, // set this from state or default
        pagesize: pageSize,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }), // set this from state or default
      })
    )
      .unwrap()
      .then(response => {
        console.log(response);
        setVerifyPackingSlipData(response?.results);
      })
      .catch(err => {
        console.error("Verification failed:", err);
        setVerifyPackingSlipData([]);
      });
  };

  useEffect(() => {
    if (selectedSlipNo) {
      handleVerifyPackingSlip();
    }
  }, [search, page, orderBy]);


  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: '8%',
      render: (text, record, index) => index + 1, // Auto-increment based on row index
    },
    {
      title: 'Bundle No.',
      dataIndex: 'bundle_no',
      key: 'bundle_no',

    },
    {
      title: 'Profile',
      dataIndex: 'die_profile',
      key: 'die_profile',

    },
    {
      title: 'Profile Description',
      dataIndex: 'profile_description',
      key: 'profile_description',

    },
    {
      title: 'Length (mm)',
      dataIndex: 'length',
      key: 'length',

    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',

    },
    {
      title: 'Weight (kg)',
      dataIndex: 'weight',
      key: 'weight',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (status ? 'Verified' : 'Unverified'),
    },

  ];
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    dispatch(resetPackingSlip());
  };
  const debounceTimeout = useRef(null);

  const handleSearch = (e) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setSearch(e.target.value);
      setPage(1);
    }, 100);
  };
  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('')
    setPageSize(pageSize);
    dispatch(resetPackingSlip());
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "bundle_no" && sortOrder === "ascend") {
      sortingEnumKey = "bundle_no";
    }
    if (sortField === "bundle_no" && sortOrder === "descend") {
      sortingEnumKey = "-bundle_no";
    }
    if (sortField === "die_profile" && sortOrder === "ascend") {
      sortingEnumKey = "die_profile";
    }
    if (sortField === "die_profile" && sortOrder === "descend") {
      sortingEnumKey = "-die_profile";
    }
    if (sortField === "profile_description" && sortOrder === "ascend") {
      sortingEnumKey = "profile_description";
    }
    if (sortField === "profile_description" && sortOrder === "descend") {
      sortingEnumKey = "-profile_description";
    }
    if (sortField === "length" && sortOrder === "ascend") {
      sortingEnumKey = "length";
    }
    if (sortField === "length" && sortOrder === "descend") {
      sortingEnumKey = "-length ";
    }
    if (sortField === "pieces" && sortOrder === "ascend") {
      sortingEnumKey = "pieces";
    }
    if (sortField === "pieces" && sortOrder === "descend") {
      sortingEnumKey = "-pieces";
    }
    if (sortField === "weight" && sortOrder === "ascend") {
      sortingEnumKey = "weight";
    }
    if (sortField === "weight" && sortOrder === "descend") {
      sortingEnumKey = "-weight";
    }
    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }
    return sortingEnumKey;
  };

  const resetFilter = () => {
    setSearch('');
    setOrderBy('');
    setPage(1);
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group value={checkedList} onChange={handleColumnVisibilityChange}>
          <Row gutter={16}>
            <Col xs={24} md={12} >
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="bundle_no">Bundle No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="die_profile">Profile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile_description">Profile Description</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length">Length</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="weight">Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="pieces">Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className='mainwrap'>
      <div className='sticyaction'>
        <div className='sticky-header'>
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Dispatch Verification</h2>
              <div className="bredcrumbwrp">
                <Link className="back" onClick={(() => { navigate(-1) })}>
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Dispatch Verification' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Input
                  placeholder="Search"
                  className='searchbox'
                  prefix={<SearchOutlined />}
                  value={search}
                  onChange={handleSearch}
                  style={{ width: '100%' }}
                />
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
                <div className="gridiconswrap">
                  <Tooltip placement="topLeft" title="Column Filter Options">
                    <Dropdown
                      overlay={columnMenu}
                      trigger={['click']}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Button
                        type="primary"
                        icon={<ColumnList />}
                        onClick={(e) => e.preventDefault()}
                      />
                    </Dropdown>
                  </Tooltip>
                </div>
              </Space>
            </Col>
          </Row>
        </div>
      </div>
   
        <div className="formwrapper" style={{display:'flex', flexDirection:'column', height:'100%'}}>
          <Form
            layout="vertical"
            form={form}
          >
            <div className="mb-3 " style={{
              backgroundColor: '#e0f2f7',
              padding: '15px', paddingBottom: "0",
              borderRadius: '5px',
              width: '100%',
            }}>
              <Row gutter={24} style={{ alignItems: 'flex-end' }}>
                <Col xs={24} md={8}>
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                    }}
                  >
                    <Form.Item
                      name="select_packing_slip_number"
                      label="Select Packing Slip Number"
                      style={{ width: '100%' }}
                    >
                      <AutoOpenSelect
                        placeholder="Select Packing Slip"
                        style={{ width: '100%' }}
                        allowClear={true}
                        showSearch={true}
                        optionFilterProp="children"
                        onChange={(value) => setSelectedSlipNo(value)}
                      >
                        {packingSlipData?.map(el => (
                          <Option key={el.slip_no} value={el.slip_no}>
                            {el.slip_no}
                          </Option>
                        ))}
                      </AutoOpenSelect>
                    </Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginTop: "25px" }}
                      onClick={handleVerifyPackingSlip}
                    >
                      View
                    </Button>
                  </div>
                </Col>

                <Col xs={24} md={8}>
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                    }}
                  >
                    <Form.Item className='w-full'
                      label="Verification Status"
                      name="die"
                    >
                      <Input placeholder="Enter Verification Status Code" />
                    </Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginTop: "25px" }}
                    >
                      View
                    </Button>
                  </div>
                </Col>

              </Row>
            </div>
            <Row gutter={16} className='mt-5'>
              <Col xs={12} sm={8} >
                <div className='widwrp' style={{ backgroundColor: '#F7F6FF' }}>
                  <div className='vidvaluerow mt-0'>
                    <div className='flex gap-2 items-center'>
                      <label style={{ fontSize: '1.3rem' }}>Total Bundle :</label>
                      <span style={{ fontSize: '1.5rem', wordBreak: "break-all", fontWeight: 'bold' }}>{verifyPackingSlipData?.total_bundles}</span>

                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={8}>
                <div className='widwrp' style={{ backgroundColor: '#e0f8e0' }}>
                  <div className='vidvaluerow mt-0'>
                    <div className='flex gap-2 items-center'>
                      <label style={{ fontSize: '1.3rem' }}>Verified :</label>
                      <span style={{ fontSize: '1.5rem', wordBreak: "break-all", fontWeight: 'bold' }}>{verifyPackingSlipData?.verified_bundles}</span>

                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={8}>
                <div className='widwrp' style={{ backgroundColor: '#FFFBF6' }}>
                  <div className='vidvaluerow mt-0'>
                    <div className='flex gap-2 items-center'>
                      <label style={{ fontSize: '1.3rem' }}>Un-Verified :</label>
                      <span style={{ fontSize: '1.5rem', wordBreak: "break-all", fontWeight: 'bold' }}>{verifyPackingSlipData?.unverified_bundles}</span>

                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
          <div className='tablewrp'>
              <Table
                className='px-0'
                rowKey="id"
                columns={filteredColumns}
                dataSource={verifyPackingSlipData?.data}
                pagination={false} // Disable built-in pagination
                loading={status === 'loading'}
                onChange={handleTableChange}
                scroll={{ x: '600px' }}
              />
            </div>
          
              <Pagination
                current={page}
                pageSize={pageSize}
                total={totalRecord}
                showSizeChanger
                onShowSizeChange={handlePageSizeChange}
                showTotal={total => `Total ${total} items`}
                pageSizeOptions={["20", "50", "100"]}
                onChange={handlePageChange}
                locale={{ items_per_page: 'Items / Page' }}
              />
       
        </div>
      </div > 
  );
}

export default DispatchVerificationList
